export enum FileUploadInfoErrorEnum {
    onUpload = 'onUpload',
    fileSize = 'fileSize',
    fileType = 'fileType',
    fileAmount = 'fileAmount'
}

export class KeyValuePair {
    constructor(data?: { key: string; value: string }) {
        if (data) {
            this.key = data.key;
            this.value = data.value;
        }
    }
    key!: string;
    value!: string;
}

export enum ModalityType {
    CT = 'CT',
    MR = 'MR',
    PlainFilm = 'PlainFilm',
    CR = 'CR',
    DX = 'DX',
    US = 'US',
    NM = 'NM',
    PT = 'PT',
    Other = 'Other'
}
